export const APP_EVENT_TYPE = {
    CLICK: 'CLICK',
    CHANGE: 'CHANGE',
    INPUT: 'INPUT',
    HOVER: 'HOVER',
    INDICATION: 'INDICATION',
    FORM_FIELD_CHANGE: 'FORM_FIELD_CHANGE',
    USER_GET_INACTIVE: 'USER_GET_INACTIVE',
    USER_GET_ACTIVE: 'USER_GET_ACTIVE',
    NAVIGATE: 'NAVIGATE',
    FORM_ACTION: 'FORM_ACTION',
    FORM_WIZARD_STEP: 'FORM_WIZARD_STEP',
    EDIT_GRID_CELL: 'EDIT_GRID_CELL',
    CHAT_TRIGGERED_ACTION: 'CHAT',
    CHAT_DIALOG_MESSAGE: 'CHAT_DIALOG_MESSAGE',
    PERFORMANCE_MEASUREMENT: 'PERFORMANCE_MEASUREMENT',
    CHAT_AGENT_MESSAGE_TIMEOUT: 'CHAT_AGENT_MESSAGE_TIMEOUT',
    VISIBLE: 'VISIBLE',
};
